var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.openExamSystem}},[_vm._v("打开课堂考核模块")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }